import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { GlobalContext } from "./context/global/context";
import { MainPage } from "./routes/Main";
import { HomePage } from "./routes/Home";
import { AdvancePage } from "./routes/Advance";
import { SecurityPage } from "./routes/Security";
import { SolutionPage } from "./routes/Solution";
import { DeveloperPage } from "./routes/Developer";
import { AboutusPage } from "./routes/AboutAuthing";
// import { PricePage } from "./routes/Price";
// import { AboutusPage } from "./routes/Aboutus";
import { PricePage } from "./routes/PricePage";
import { SSOPage } from "./routes/SSOPage";
import { MultiplePage } from "./routes/Multiple";
import { DatabasePage } from "./routes/DatabasePage";
import { VerifyPage } from "./routes/VerifyPage";
import { JoinusPage } from "./routes/JoinusPage";
import { LogPage } from "./routes/Log";
import { NotFoundPage } from "./routes/NotFound";
import { BlogHomePage } from "./routes/Blog/Home";
import { BlogDetailPage } from "./routes/Blog/Detail";
import { BlogEditPage } from "./routes/Blog/Edit";
import { BlogTagPage } from "./routes/Blog/Tag";
import { BlogPublishPage } from "./routes/Blog/Publish";
import { ActivityPage } from "./routes/Activity";
import { TopicPage } from "./routes/Topic";
import { WechatPage } from "./routes/solutions/Wechat";
import { IdaasPage } from "./routes/solutions/Idaas";
import { OktaPage } from "./routes/solutions/Okta";
// import { ADPage } from "./routes/AD";
import { BuildIdaasPage } from "./routes/solutions/BuildIdaas";
import { CognitoPage } from "./routes/solutions/Cognito";

import { KeycloakPage } from "./routes/solutions/Keycloak";

import { BuildADPage } from "./routes/BuildAD";

import { getCookie, setCookie, getDefaultLang } from "./utils";
import classnames from "classnames";
import "./App.less";
import { HeighEducatePage } from "./routes/HeighEducate";
import { CustomerPage } from "./routes/CustomerPage";
import { CNPNPage } from "./routes/CNPN";
import { SouthEastPage } from "./routes/SouthEast";
import { DeephowPage } from "./routes/Deephow";
import { BentleyPage } from "./routes/Bentley";
import { PrivateCloudPage } from "./routes/PrivateCloud";
import { RouterGuard } from "./components/RouterGuard";
import { ApplicationPage } from "./routes/Application";
import { MarketplacePage } from "./routes/Marketplace";
import { MarketplaceDetailPage } from "./routes/MarketplaceDetail";
import { GatewayIntegrationPage } from "./routes/Gateway";
import { CloudOriginal } from "./routes/CloudOriginal";
// import { PrivateCloudPricePage } from "./routes/PrivateCloudPrice";
import querystring from "query-string";
import { GuardPage } from "./routes/Guard";
import { HelloPage } from "./routes/hello";
import { JCDecauxPage } from "./routes/customers/JCDecaux";
import { BentleyMotorsPage } from "./routes/customers/BentelyMotors";
import { YuanqiPage } from "./routes/customers/Yuanqi";
import { VolkswagenPage } from "./routes/customers/Volkswagen";
import { ToyotaPage } from "./routes/customers/Toyota";
import { HuaxiPage } from "./routes/customers/Huaxi";
import { BoschPage } from "./routes/customers/Bosch";
import { PingcapPage } from "./routes/customers/PingCap";
import { ChatRobot } from "./components/ChatRobot";
import { SolutionIndustryPage } from "./routes/solutions/Industry";
import { JobDetail } from "./routes/Joinus/Detail";
import { ToolPackage } from "./routes/ToolPackage";
import { PayNewsPage } from "./routes/PayNews";
import { CocaColaPage } from "./routes/customers/CocaCola";
import { ContactBar } from "./components/ContactBar";
import { AuthorityPage } from "./routes/Authority";
import { registerLogTrack } from "@authing/log";
import { TimelinePage } from "./routes/Timeline";
import { PartnerPage } from "./routes/Partner";
import { AuthingForm } from "./routes/AuthingForm";

// let main = () => {
//   let r = typeof window !== "undefined";
//   if (!r) {
//     return;
//   }
//   window.onload = () => {
//     // useEffect(() => {
//     // 读取并写入 sessionStorage
//     let search = querystring.parse(window.location.search);
//     Object.keys(search).forEach((k) => {
//       let v = search[k];
//       console.log("写入时", k, v);
//       sessionStorage.setItem(k, v);
//     });
//     //   }, []);
//   };
// };

// main();

function App(props) {
  const lang = props.lang || getDefaultLang();
  const initData = props.initData;
  const isMobile = props.initData?.isMobile ? props.initData.isMobile : null;
  // const [visible, setVisible] = useState(false);
  // const isMobile = "mobile";
  // const { pathname } = useLocation();
  const reportEvents = (...res) => {
    window.collectEvent(...res);
  };
  // 火山引擎埋点
  // useEffect(() => {
  //   const callbacks = {
  //     reportFunc: (m) => {
  //       let body = {
  //         s: m.site,
  //         p: m.page,
  //         b: m.block,
  //         e: m.element,
  //         uid: m.uid,
  //         upid: m.upid,
  //       };
  //       if (window.collectEvent) {
  //         reportEvents(m.name, body);
  //       }
  //     },
  //   };

  //   const config = {
  //     defaultSite: "ow",
  //     defaultPage: "index",
  //   };

  //   const authingLog = registerLogTrack(callbacks, config);
  // }, []);
  useEffect(() => {
    // 读取并写入 sessionStorage
    let search = window.location.search
      ? querystring.parse(
          typeof window !== "undefined" && window.location.search
        )
      : "";
    if (search) {
      console.log(search, "search");
      Object.keys(search).forEach((k) => {
        let v = search[k];
        // console.log("写入时", k, v);
        sessionStorage.setItem(k, v);
      });
      return;
    }
    // const originCLue = window.location.origin;
    const originCLue = document.referrer;

    if (originCLue.indexOf("docs.authing.cn") !== -1) {
      ["utm_term", "utm_source", "utm_campaign", "utm_medium"].forEach((k) => {
        let v = getCookie(k);
        sessionStorage.setItem(k, v);
      });
    }
    // } else {
    //   ["utm_term", "utm_source", "utm_campaign", "utm_medium"].forEach(
    //     (name) => {
    //       setCookie(name, "");
    //       console.log(name, "clear");
    //     }
    //   );
    // }
  }, []);

  // useTimeoutFn(() => {
  //   setVisible(true);
  // }, 60 * 60 * 60);
  return (
    <GlobalContext value={{ lang, userInfo: null, isMobile: isMobile }}>
      <div className={classnames(["App", `lang-${lang}`])}>
        <Routes>
          <Route
            path="/"
            element={
              <RouterGuard mobileMeta={true}>
                <HomePage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/login"
            element={
              <RouterGuard>
                <MainPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/advantage"
            element={
              <RouterGuard>
                <AdvancePage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/security"
            element={
              <RouterGuard>
                <SecurityPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/solution"
            element={
              <RouterGuard>
                <SolutionPage {...initData} />
              </RouterGuard>
            }
          />
          {/* <Route
            path="/solutions*"
            element={
              <RouterGuard>
                <SolutionPage {...initData} />
              </RouterGuard>
            }
          /> */}
          <Route
            path="/solutions/:type"
            element={
              <RouterGuard mobileMeta={true}>
                <SolutionIndustryPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/solutions/wechat"
            element={
              <RouterGuard mobileMeta={true}>
                <WechatPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/solutions/idaas"
            element={
              <RouterGuard mobileMeta={true}>
                <IdaasPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/solutions/okta"
            element={
              <RouterGuard mobileMeta={true}>
                <OktaPage {...initData} />
              </RouterGuard>
            }
          />
          {/* <Route path="/solutions/ad" element={<ADPage {...initData} />} /> */}
          <Route
            path="/solutions/build-idaas"
            element={
              <RouterGuard mobileMeta={true}>
                <BuildIdaasPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/solutions/cognito"
            element={
              <RouterGuard mobileMeta={true}>
                <CognitoPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/solutions/keycloak"
            element={
              <RouterGuard mobileMeta={true}>
                <KeycloakPage {...initData} />
              </RouterGuard>
            }
          />
          {/* <Route
            path="/solutions/mfa"
            element={
              <RouterGuard>
                <MfaPage {...initData} />
              </RouterGuard>
            }
          /> */}
          <Route
            path="/solutions/ad"
            element={
              <RouterGuard>
                <BuildADPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer"
            element={
              <RouterGuard mobileMeta={true}>
                <CustomerPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/hep"
            element={
              <RouterGuard mobileMeta={true}>
                <HeighEducatePage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/cnpn"
            element={
              <RouterGuard mobileMeta={true}>
                <CNPNPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/southeast-university"
            element={
              <RouterGuard mobileMeta={true}>
                <SouthEastPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/deephow"
            element={
              <RouterGuard mobileMeta={true}>
                <DeephowPage {...initData} />
              </RouterGuard>
            }
          />

          <Route
            path="/customer/bentley"
            element={
              <RouterGuard mobileMeta={true}>
                <BentleyPage {...initData} />
              </RouterGuard>
            }
          />

          <Route
            path="/customer/jcdecaux"
            element={
              <RouterGuard mobileMeta={true}>
                <JCDecauxPage {...initData} />
              </RouterGuard>
            }
          />

          <Route
            path="/customer/bentley-motors"
            element={
              <RouterGuard mobileMeta={true}>
                <BentleyMotorsPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/yuanqi"
            element={
              <RouterGuard mobileMeta={true}>
                <YuanqiPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/volkswagen"
            element={
              <RouterGuard mobileMeta={true}>
                <VolkswagenPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/toyota"
            element={
              <RouterGuard mobileMeta={true}>
                <ToyotaPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/west-china-hospital"
            element={
              <RouterGuard mobileMeta={true}>
                <HuaxiPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/bosch"
            element={
              <RouterGuard mobileMeta={true}>
                <BoschPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/pingcap"
            element={
              <RouterGuard mobileMeta={true}>
                <PingcapPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/coca-cola"
            element={
              <RouterGuard mobileMeta={true}>
                <CocaColaPage {...initData} />
              </RouterGuard>
            }
          />
          {/* <Route
            path="/customer/xian-gong"
            element={
              <RouterGuard>
                <XianGongPage {...initData} />
              </RouterGuard>
            }
          /> */}
          {/* <Route
            path="/customer/futu"
            element={
              <RouterGuard>
                <FutuPage {...initData} />
              </RouterGuard>
            }
          /> */}
          <Route
            path="/developer"
            element={
              <RouterGuard>
                <DeveloperPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/about"
            element={
              <RouterGuard mobileMeta={true}>
                <AboutusPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/pricing"
            element={
              <RouterGuard mobileMeta={true}>
                <PricePage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/learn/guard"
            element={
              <RouterGuard mobileMeta={true}>
                <GuardPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/mfa"
            element={
              <RouterGuard mobileMeta={true}>
                <MultiplePage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/database-connection"
            element={
              <RouterGuard mobileMeta={true}>
                <DatabasePage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/authorization-management"
            element={
              <RouterGuard mobileMeta={true}>
                <AuthorityPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/gateway-integration"
            element={
              <RouterGuard mobileMeta={true}>
                <GatewayIntegrationPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/cloud-native"
            element={
              <RouterGuard mobileMeta={true}>
                <CloudOriginal {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/learn/sso"
            element={
              <RouterGuard mobileMeta={true}>
                <SSOPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/verify"
            element={
              <RouterGuard mobileMeta={true}>
                <VerifyPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/joinus"
            element={
              <RouterGuard mobileMeta={true}>
                <JoinusPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/joinus/:id"
            element={
              <RouterGuard mobileMeta={true}>
                <JobDetail {...initData} />
              </RouterGuard>
            }
          />
          {/* <Route
            path="/changelog"
            element={
              <RouterGuard>
                <LogPage {...initData} />
              </RouterGuard>
            }
          /> */}
          <Route
            path="/changelog"
            element={
              <RouterGuard mobileMeta={true}>
                <TimelinePage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/error/404"
            element={
              <RouterGuard>
                <NotFoundPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/blog"
            element={
              <RouterGuard>
                <BlogHomePage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/topic"
            element={
              <RouterGuard>
                <TopicPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/activity"
            element={
              <RouterGuard>
                <ActivityPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/solutions/private-cloud"
            element={
              <RouterGuard>
                <PrivateCloudPage {...initData} />
              </RouterGuard>
            }
          />
          {/* <Route
            path="/private-cloud-price"
            element={<PrivateCloudPricePage {...initData} />}
          /> */}

          <Route
            path="/blog/:id"
            element={
              <RouterGuard>
                <BlogDetailPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/blog/edit/:id"
            element={
              <RouterGuard>
                <BlogEditPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/blog/tag/:id"
            element={
              <RouterGuard>
                <BlogTagPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/blog/publish"
            element={
              <RouterGuard>
                <BlogPublishPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/pay-news"
            element={
              <RouterGuard>
                <PayNewsPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/apn/intro"
            element={
              <RouterGuard mobileMeta={true}>
                <ApplicationPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/apn"
            element={
              <RouterGuard mobileMeta={true}>
                {/* <MarketplacePage {...initData} /> */}
                <MarketplacePage />
              </RouterGuard>
            }
          />
          <Route
            path="/apn/detail/:id"
            element={
              <RouterGuard mobileMeta={true}>
                <MarketplaceDetailPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/welcome"
            element={
              <RouterGuard>
                <HelloPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/partner"
            element={
              <RouterGuard mobileMeta={true}>
                <PartnerPage {...initData} />
              </RouterGuard>
            }
          />

          <Route
            path="/tool-package"
            element={
              <RouterGuard>
                <ToolPackage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/authingform"
            element={
              <AuthingForm>
                <ToolPackage {...initData} />
              </AuthingForm>
            }
          />
        </Routes>
        {/* <ChatRobot /> */}
        <ContactBar />
        {/* <ConsultFormModal {...{ visible, setVisible }} /> */}
      </div>
    </GlobalContext>
  );
}

export default App;
